/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {firestoreAction} from 'vuexfire';
import {db} from '@/firebaseConfig';

const actions = {

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width);
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload);
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list);
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list);
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY');
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val);
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    updateUserInfo({ commit }, payload) {
      commit('UPDATE_USER_INFO', payload);
    },

  // ////////////////////////////////////////////
  // Cloud FireStore actions
  // ////////////////////////////////////////////

  bindParameters: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('parameters', db.collection('parameters'));
  }),

  bindCategories: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('categories', db.collection('catalogs').doc('categories'));
  }),

  bindVersions: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('versions', db.collection('filters').doc('versions'));
  }),

  bindFontSizes: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('fontSizes', db.collection('filters').doc('fontSizes'));
  }),

  bindProducts: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('products', db.collection('catalogs').doc('products'));
  }),

  bindCoupons: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('coupons', db.collection('catalogs').doc('coupons'));
  }),

  bindSliders: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('sliders', db.collection('home').doc('sliderProducts'));
  }),

  bindShowcase: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('showcase', db.collection('home').doc('showcaseProducts'));
  })

};

export default actions;
